import { dataCamera } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCamera = /*#__PURE__*/createIcon(dataCamera)
export default IconCamera
